import React, { useCallback } from "react";
import {
  makeStyles,
  Textarea,
  TextareaOnChangeData,
} from "@fluentui/react-components";

/* global HTMLTextAreaElement */

const useStyles = makeStyles({
  fullWidth: {
    width: "100%",
  },
});

interface TextareaFieldProps {
  value?: string;
  placeholder?: string;
  rows?: number;
  onChange: (value: string) => void;
}

export const TextareaField: React.FC<TextareaFieldProps> = ({
  value,
  placeholder,
  rows,
  onChange,
}) => {
  const styles = useStyles();

  const handleChange = useCallback(
    (_e: React.ChangeEvent<HTMLTextAreaElement>, data: TextareaOnChangeData) =>
      onChange(data.value),
    [onChange],
  );

  return (
    <Textarea
      className={styles.fullWidth}
      rows={rows}
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
    />
  );
};

export default React.memo(TextareaField);
